import { useCallback, useEffect, useRef } from 'react';

enum EventType {
    MouseDown = 'mousedown',
    TouchStart = 'touchstart',
}

type AnyEvent = MouseEvent | TouchEvent;

export const useOnClickOutside = <T extends HTMLElement>(handler: (event: AnyEvent) => void) => {
    const ref = useRef<T | null>(null);

    const handleEvent = useCallback(
        (event: AnyEvent) => {
            const el = ref?.current;

            if (!el || el.contains(event.target as Node)) {
                return;
            }

            handler(event);
        },
        [handler]
    );

    useEffect(() => {
        document.addEventListener(EventType.MouseDown, handleEvent);
        document.addEventListener(EventType.TouchStart, handleEvent);

        return () => {
            document.removeEventListener(EventType.MouseDown, handleEvent);
            document.removeEventListener(EventType.TouchStart, handleEvent);
        };
    }, [handleEvent]);

    return ref;
};
